export const LookupModel = 
  {
    subjects : [],    
    acadPrograms : [],
    acadProgramLevels : [],
    terms: []
  }